import gql from "graphql-tag";

export const GetProfileAlerts = gql`
  query GetProfileAlerts($ProfileId: ID!) {
    GetProfileAlerts(ProfileId: $ProfileId) {
      ProfileAlerts {
        Active
        AlertType
        CreatedAt
        ObjectId
        ObjectType
        ProfileAlertId
        ProfileId
        TaxYear
        UpdatedAt
        TriggerAlert
      }
      TotalTokens
    }
  }
`;
